module.exports = __webpack_public_path__ + "img/facebook_messenger.1bee6daa.svg";